import api from './valueFormatterModule';

angular.module('sfx.ui').factory('valueFormatter', [
    function () {
        return api;
    },
]);
